import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    CartOverlayContainer as SourceCartOverlayContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/CartOverlay/CartOverlay.container';
import { getCartSubtotal } from 'Util/Cart/Cart';

/** @namespace PeggysagePwa/Component/CartOverlay/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    cartSubtotal: getCartSubtotal(state),
    currencyCode: state.ConfigReducer.default_display_currency_code
});

/** @namespace PeggysagePwa/Component/CartOverlay/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // ...
});

/** @namespace PeggysagePwa/Component/CartOverlay/Container */
export class CartOverlayContainer extends SourceCartOverlayContainer {
    static propTypes = {
        ...SourceCartOverlayContainer.propTypes,
        cartSubtotal: PropTypes.number
    };

    static defaultProps = {
        ...SourceCartOverlayContainer.defaultProps,
        cartSubtotal: 0
    };

    containerProps() {
        const { cartSubtotal } = this.props;

        return {
            ...super.containerProps(),
            cartSubtotal
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartOverlayContainer);
